import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["aria-label", "accessibilityLabel", "gray", "height", "id", "inverse", "testID", "UNSAFE_svgProps", "UNSAFE_pathStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Shape } from '@bubble-ui/primitive-shape';
import { Surface } from '@bubble-ui/primitive-surface';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { withProvisionalOverrideFromContext } from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var viewBoxWidth = 19;
var viewBoxHeight = 20;
var KlarnaLogoSingleLetterComponent = _ref => {
  var {
      'aria-label': ariaLabel,
      accessibilityLabel: ariaLabelDeprecated,
      gray,
      height = 20,
      id,
      inverse,
      testID,
      UNSAFE_svgProps,
      UNSAFE_pathStyle
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'KlarnaLogoSingleLetter',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  var designVersion = useDesignVersion();
  var {
    rootStyle
  } = getDefaultStyleSheet({
    designVersion,
    gray,
    inverse
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    "aria-label": ariaLabel || ariaLabelDeprecated,
    width: viewBoxWidth / viewBoxHeight * height,
    height: height,
    viewBox: "0 0 ".concat(viewBoxWidth, " ").concat(viewBoxHeight),
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Shape, _extends({
    d: "M16.443 -9.15527e-05H12.0894C12.0894 3.57134 9.89837 6.77134 6.56914 9.05705L5.26021 9.97134V-9.15527e-05H0.735863V19.9999H5.26021V10.0856L12.7439 19.9999H18.2641L11.065 10.5142C14.3374 8.14277 16.4715 4.45705 16.443 -9.15527e-05Z"
  }, _objectSpread(_objectSpread({}, rootStyle), UNSAFE_pathStyle))));
};
KlarnaLogoSingleLetterComponent.displayName = 'KlarnaLogoSingleLetter';
export var KlarnaLogoSingleLetter = withProvisionalOverrideFromContext(KlarnaLogoSingleLetterComponent);
//# sourceMappingURL=index.js.map